import { CounterController } from './counter-controller';
import model from './model';
import type { ControllerParams } from './types';

const createController = model.createController((controller) => {
  return new CounterController(controller as ControllerParams);
});

export default createController;
